import { useState } from 'react';
import { AlertCircle } from 'lucide-react';
import { acceptP2PDisclaimer } from '../../services/p2pService';

interface Props { onAccept: () => void; onCancel: () => void; }

export default function DisclaimerModal({ onAccept, onCancel }: Props) {
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    setLoading(true);
    try { await acceptP2PDisclaimer(); } catch { /* ignore */ }
    onAccept();
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--p2p-bg-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div className="p2p-modal-box" style={{ maxWidth: 360 }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, textAlign: 'center' }}>
          <div style={{ width: 60, height: 60, borderRadius: '50%', background: '#F0B90B', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <AlertCircle size={30} color="#000" />
          </div>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: 'var(--p2p-text-primary)' }}>Disclaimer</h2>
          <p style={{ fontSize: 14, color: 'var(--p2p-text-secondary)', lineHeight: 1.6 }}>
            P2P trading involves direct transactions between users. Bicoin provides the platform but does not guarantee transactions. Always verify payment before releasing crypto. By proceeding, you agree to our{' '}
            <span style={{ color: 'var(--p2p-buy)', cursor: 'pointer' }}>Privacy Notice</span>{' '}
            and P2P trading rules.
          </p>
          <label className="p2p-checkbox-row" style={{ textAlign: 'left', width: '100%' }}>
            <input type="checkbox" className="p2p-checkbox" checked={checked} onChange={e => setChecked(e.target.checked)} />
            <span style={{ fontSize: 13, color: 'var(--p2p-text-secondary)' }}>I have read and agree to the notice</span>
          </label>
          <button className="p2p-btn-yellow" disabled={!checked || loading} onClick={handleAccept} style={{ marginTop: 8 }}>
            {loading ? 'Processing...' : 'OK'}
          </button>
          <button className="p2p-btn-ghost" onClick={onCancel} style={{ width: '100%' }}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
